import s from '@widgets/Common/Footer/Footer.module.sass'
import { Text } from '@shared/ui/Typography/Text'
import React, { FC } from 'react'
import Link from 'next/link'
import { EGG } from '@shared/api/analytics'
import { useParams, useRouter } from 'next/navigation'
import { useAppSelector } from '@app/model/store'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { FooterFoundMistakeOpener } from '@widgets/Common/Footer/components/FooterFoundMistakeOpener'

const addUTM = (thisLink, thisName = '') => {
  const UTM_STR = '?utm_source=restaurants&utm_medium=referral&utm_campaign=footer'
  const isRestsLink = thisName.toLowerCase() === 'рестораны'
  const filteredLink = thisLink.at(-1) === '/' ? thisLink : thisLink + '/'
  const output = isRestsLink ? thisLink : filteredLink + UTM_STR
  return output
}

const getNavigation = (citySlug: string) => {
  return {
    main: [
      { id: 'main-1', href: 'https://www.afisha.ru/rests/restaurants_mediakit.pdf', text: 'Медиа-кит' },
      { id: 'main-2', href: 'https://www.afisha.ru/article/about/', text: 'О компании' },
      { id: 'main-3', href: 'https://www.afisha.ru/article/advertising/', text: 'Реклама' },
      { id: 'main-4', href: `/${citySlug}/restaurants/tags/`, text: 'Карта сайта' },
      { id: 'main-5', href: 'https://www.afisha.ru/article/contact/', text: 'Контакты' },
    ],
    projects: [
      { id: 'projects-1', href: addUTM('https://daily.afisha.ru/'), text: 'Афиша Daily' },
      { id: 'projects-2', href: addUTM('https://picnic.afisha.ru/'), text: 'Пикник «Афиши»' },
      { id: 'projects-3', href: addUTM('https://www.afisha.ru/guides/'), text: 'Путеводители' },
      { id: 'projects-4', href: 'https://eda.ru/', text: 'Еда.ру' },
    ],
    other: [
      { id: 'other-1', href: `/${citySlug}/restaurants/restorator/`, text: 'Рестораторам' },
      { id: 'add-establishment', text: 'Добавить заведение', onClick: 'add-establishment' },
      { id: 'other-3', href: addUTM('https://www.afisha.ru/certificates/'), text: 'Сертификаты' },
    ],
  }
}

export const FooterNavigation: FC = () => {
  const params = useParams()
  const router = useRouter()
  const storeCurrentCitySlug = useAppSelector((state) => state.global.currentCity?.slug)
  const citySlug = storeCurrentCitySlug || params?.city_slug[0] || 'msk'
  const { isMobile } = useClientResponsive()
  const navigation = getNavigation(citySlug)

  const handleOpenAddEstablishment = () => {
    EGG.footer.menu_item_click({ button_name: 'Добавить заведение' })
    router.push(`/${citySlug}/restaurants/restorator/reg`)
  }
  const getLinksList = (array) => {
    const onClickMethods = {
      'add-establishment': handleOpenAddEstablishment,
    }

    return array.map((el) => {
      if ('href' in el) {
        return (
          <Text key={el.id} tag={'span'} sizes={'M S M'}>
            <Link
              href={el.href}
              target='_blank'
              onClick={() => EGG.footer.menu_item_click({ button_name: el.text })}
              rel='noreferrer'
              className={s['navigation-link']}
              scroll={false}>
              {el.text}
            </Link>
          </Text>
        )
      } else if ('onClick' in el) {
        return (
          <Text
            key={el.id}
            tag={'span'}
            sizes={'M'}
            className={s['navigation-link']}
            onClick={onClickMethods[el.onClick]}>
            {el.text}
          </Text>
        )
      } else {
        return null
      }
    })
  }
  return (
    <div className={s.navigation}>
      {isMobile ? (
        <>
          <div className={`${s['navigation-col']}`}>{getLinksList(navigation.projects)}</div>
          <div className={s['navigation-separator']}></div>
          <div className={s['navigation-col']}>
            {getLinksList(navigation.main)} {getLinksList(navigation.other)} <FooterFoundMistakeOpener />
          </div>
        </>
      ) : (
        <>
          <div className={s['navigation-col']}>{getLinksList(navigation.main)}</div>
          <div className={`${s['navigation-col']} ${s['navigation-col--projects']}`}>
            {getLinksList(navigation.projects)}
          </div>
          <div className={s['navigation-col']}>{getLinksList(navigation.other)}</div>
        </>
      )}
    </div>
  )
}
